var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","appear":""}},[_c('div',{staticClass:"importing"},[_c('img',{attrs:{"src":require("../assets/img/loading.svg"),"alt":"Зареждане..."}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }